import * as React from 'react'
export const Br = (props: React.SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342" width="1em" height="1em" {...props}>
    <path fill="#009b3a" d="M0 0h513v342H0z" />
    <path fill="#fedf00" d="m256.5 19.3 204.9 151.4L256.5 322 50.6 170.7z" />
    <circle cx={256.5} cy={171} r={80.4} fill="#FFF" />
    <path
      fill="#002776"
      d="M215.9 165.7c-13.9 0-27.4 2.1-40.1 6 .6 43.9 36.3 79.3 80.3 79.3 27.2 0 51.3-13.6 65.8-34.3-24.9-31-63.2-51-106-51m119 20.3c.9-5 1.5-10.1 1.5-15.4 0-44.4-36-80.4-80.4-80.4-33.1 0-61.5 20.1-73.9 48.6 10.9-2.2 22.1-3.4 33.6-3.4 46.8.1 89 19.5 119.2 50.6"
    />
  </svg>
)
